module.exports = __webpack_public_path__ + "static/img/statusCorrect.177561c1.png";